<template>
  <div class="page faq">
    <div class="content">
      <p>- made for fun</p>
      <p>- that's all folks, see ya</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NewVueComponent',
    props: {},
    components: {},
    watch: {},
    data () {
      return {}
    },
    methods: {},
    computed: {},
    mounted () {
    }
  }
</script>

<style lang="scss" scoped>
  .page.faq .content {
    padding: 30px;
    font-size: 15px;
    text-transform: uppercase;
    p {
      padding: 2px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/About.vue